/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalInformationViewModel } from './ProposalInformationViewModel';
import {
    ProposalInformationViewModelFromJSON,
    ProposalInformationViewModelFromJSONTyped,
    ProposalInformationViewModelToJSON,
} from './ProposalInformationViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfProposalInformationViewModel
 */
export interface ResultOfProposalInformationViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfProposalInformationViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalInformationViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalInformationViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalInformationViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalInformationViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfProposalInformationViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfProposalInformationViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ProposalInformationViewModel}
     * @memberof ResultOfProposalInformationViewModel
     */
    data?: ProposalInformationViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalInformationViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfProposalInformationViewModel interface.
 */
export function instanceOfResultOfProposalInformationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfProposalInformationViewModelFromJSON(json: any): ResultOfProposalInformationViewModel {
    return ResultOfProposalInformationViewModelFromJSONTyped(json, false);
}

export function ResultOfProposalInformationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfProposalInformationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ProposalInformationViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfProposalInformationViewModelToJSON(value?: ResultOfProposalInformationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ProposalInformationViewModelToJSON(value.data),
        'Count': value.count,
    };
}

